import { render, staticRenderFns } from "./economy.vue?vue&type=template&id=c15101e8&scoped=true&"
import script from "./economy.vue?vue&type=script&lang=js&"
export * from "./economy.vue?vue&type=script&lang=js&"
import style0 from "./economy.vue?vue&type=style&index=0&id=c15101e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15101e8",
  null
  
)

export default component.exports